import { render, staticRenderFns } from "./KeyIcon.vue?vue&type=template&id=1dd57d4c&"
import script from "./KeyIcon.vue?vue&type=script&lang=js&"
export * from "./KeyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports